<template>
  <div>
    <!--    :only-countries="countriesOnly"
    :translations="translations"-->
    <VuePhoneNumberInput
      v-model="phoneNumber"
      id="phone"
      name="phone_field"
      :default-country-code="defaultCountry"
      :show-code-on-list="true"
      :required="true"
      :border-radius="2"
      @update="setData"
    ></VuePhoneNumberInput>
    <input
      type="hidden"
      name="phone_country_code"
      :value="phone_country_code"
    />
    <input type="hidden" name="phone" :value="phone_formatted" />
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
export default {
  name: 'Phone',
  components: { VuePhoneNumberInput },
  props: {},
  data() {
    return {
      phoneNumber: null,
      phone_country_code: null,
      phone_formatted: null,
      defaultCountry: 'NO',
      //countriesList: ['NO', 'LT', 'SE', 'GB'],
      //countriesOnly: ['NO', 'LT', 'SE', 'GB', 'PL', 'DE', 'ES', 'LV'],
      countriesIgnored: ['AF', 'AD', 'AL'],
      /*      translations: {
        countrySelectorLabel: 'Šalies kodas',
        countrySelectorError: 'Šalies pasirinkimas',
        phoneNumberLabel: 'Mob. telefono numeris',
        example: 'Pavyzdys :'
      },*/
      results: {},
      dark: false,
      disabled: false,
      hasLoaderActive: false,
      hasErrorActive: false
    }
  },
  computed: {},
  methods: {
    setData(data) {
      this.phone_country_code = data.countryCallingCode
      this.phone_formatted = data.formattedNumber
    }
  }
}
</script>
